module.exports = __webpack_public_path__ + "static/media/DEVICE_ID.a812dcff.svg";